const cod5AnalyticsScriptId = "G-LWFF48SDBD";
const cod5AnalyticsConfigIds = ["G-LWFF48SDBD"];

declare global {
  interface Window {
    COD5_ANALYTICS_ID?: string;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function installAnalytics() {
  const measurementId = window.COD5_ANALYTICS_ID || cod5AnalyticsScriptId;
  const configIds = window.COD5_ANALYTICS_ID ? [window.COD5_ANALYTICS_ID] : cod5AnalyticsConfigIds;
  if (!measurementId || document.querySelector(`script[data-cod5-analytics="${measurementId}"]`)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag("set", "linker", { domains: ["nobresracoes.com.br"] });
  window.gtag("js", new Date());
  for (const configId of configIds.length ? configIds : [measurementId]) {
    window.gtag("config", configId);
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.cod5Analytics = measurementId;
  document.head.appendChild(script);
}
